import EmployeeInfo from '@/components/CustomComponent/EmployeeInfo/EmployeeInfo';
import ReactImageMarkerNotDraggable from '@/components/CustomComponent/ReactImageMarkerNotDraggable';
import { COMMON_TEXT } from '@/helpers/common-text';
import { EmployeeMarkerRender } from '@/helpers/employee-marker';
import { InputSwitch } from 'primereact/inputswitch';
import { Message } from 'primereact/message';
import { Sidebar } from 'primereact/sidebar';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { transformPositionToMarkerCoordinate } from 'src/helpers/utility';
import { QUERY_STRING_STORE } from '@/helpers/constants';
import FollowersOnlyToggle from '../FollowersOnlyToggle';

@connect(state => ({
  querystring: state.querystring,
  sessionStore: state.session,
}))
class EmployeeLocationMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      branch: '',
      tenant: '',
      data: [],
      isLoading: false,
      floorMapUrl: '',
      sidebarVisible: false,
      selectedEmployeeInfo: null,
    };
    this.mapZoomRef = React.createRef();
  }

  componentDidMount() {
    const { data: floorMapData, isLoading, floorMapUrl } = this.props;

    this.setState({
      data: floorMapData,
      isLoading,
      floorMapUrl,
    });

    // Add event listener for close sidebar
    document.addEventListener('closeSidebar', this.handleCloseSidebar);
  }

  componentWillUnmount() {
    // Remove event listener
    document.removeEventListener('closeSidebar', this.handleCloseSidebar);
  }

  handleCloseSidebar = () => {
    this.setState({ sidebarVisible: false, selectedEmployeeInfo: null });
  };

  componentDidUpdate(prevProps) {
    const {
      querystring,
      data: floorMapData,
      isLoading,
      floorMapUrl,
    } = this.props;

    const { querystring: prevQuerystring, data: prevData } = prevProps;
    const floor = querystring?.[QUERY_STRING_STORE.SELECT_BOX_FLOOR]?.[0];
    const branch = querystring?.[QUERY_STRING_STORE.SELECT_BOX_BRANCH]?.[0];
    const tenant = querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const prevFloor =
      prevQuerystring?.[QUERY_STRING_STORE.SELECT_BOX_FLOOR]?.[0];
    const prevBranch =
      prevQuerystring?.[QUERY_STRING_STORE.SELECT_BOX_BRANCH]?.[0];
    const isFloorChanged = floor !== prevFloor;
    const isBranchChanged = branch !== prevBranch;
    const isDataChanged = floorMapData !== prevData;

    if (isBranchChanged || isFloorChanged || isDataChanged) {
      this.setState({
        branch,
        tenant,
        data: floorMapData,
        isLoading,
        floorMapUrl,
      });
    }
  }

  getFloorMapDataMarkers = ({ floorMapData, isDisplayAllDeviceChecked }) => {
    const { isFollowersOnlyChecked, followedEmployeeIds } = this.props;

    const cloneFloorMapDataList = floorMapData.map(item => {
      return { ...item };
    });

    let floorMapDataMarkers = cloneFloorMapDataList.filter(item => {
      const { employee_id, location_info } = item;
      if (!employee_id || !location_info || location_info.length === 0) {
        return false;
      }

      // Filter by followed status if toggle is on
      if (isFollowersOnlyChecked && followedEmployeeIds && !followedEmployeeIds.has(employee_id)) {
        return false;
      }

      return true;
    });

    floorMapDataMarkers = floorMapDataMarkers.reduce((array, item) => {
      const { location_info } = item;
      // location_info is an array of location info
      // flaten location_info to array of marker
      if (location_info && location_info.length > 0) {
        if (isDisplayAllDeviceChecked) {
          // Show all devices when "All Devices" is checked
          location_info.forEach(info => {
            const { position_x, position_y } = info;
            if (position_x && position_y) {
              const { top, left } = transformPositionToMarkerCoordinate({
                x: position_x,
                y: position_y,
              });
              array.push({
                ...item,
                ...info,
                top,
                left,
              });
            }
          });
        } else {
          // Show only one marker per employee when "All Devices" is unchecked
          // Priority: mobile marker first, then PC marker
          let pcMarker = null;
          let mobileMarker = null;

          location_info.forEach(info => {
            if (info.device_type === 'pc') {
              pcMarker = info;
            } else if (info.device_type === 'phone') {
              mobileMarker = info;
            }
          });

          let displayMarker = null;
          if (mobileMarker) {
            displayMarker = mobileMarker;
          } else if (pcMarker) {
            displayMarker = pcMarker;
          }

          if (displayMarker) {
            const { position_x, position_y } = displayMarker;
            if (position_x && position_y) {
              const { top, left } = transformPositionToMarkerCoordinate({
                x: position_x,
                y: position_y,
              });
              array.push({
                ...item,
                ...displayMarker,
                top,
                left,
              });
            }
          }
        }
      }
      return array;
    }, []);

    for (const dataMarker of floorMapDataMarkers) {
      delete dataMarker.location_info;
    }
    return floorMapDataMarkers;
  };

  updateAllDeviceChecked = ({ isCheck }) => {
    this.props.updateAllDeviceChecked({
      isCheck: isCheck,
    });
  };

  render() {
    const {
      data: floorMapData,
      floorMapUrl,
      sidebarVisible,
      selectedEmployeeInfo,
    } = this.state;
    const { isDisplayAllDeviceChecked, floorMapError } = this.props;

    const floorMapDataMarkers = this.getFloorMapDataMarkers({
      floorMapData,
      isDisplayAllDeviceChecked,
    });

    const triggerEmployeeDetailSidebar = marker => {
      this.setState({
        sidebarVisible: true,
        selectedEmployeeInfo: { ...marker },
      });
    };

    return (
      <div style={{ height: '100%' }}>
        <Sidebar
          visible={sidebarVisible}
          onHide={() =>
            this.setState({ sidebarVisible: false, selectedEmployeeInfo: null })
          }
          closeIcon="pi pi-chevron-left"
          position="right"
          closeOnEscape={true}
          dismissable={true}
          className="employee-info-sidebar"
          showCloseIcon={false}
        >
          <EmployeeInfo
            employeeId={selectedEmployeeInfo?.['employee_id']}
            deviceType={selectedEmployeeInfo?.['device_type']}
            followedEmployeeIds={this.props.followedEmployeeIds}
            onFollowChange={this.props.onFollowChange}
          ></EmployeeInfo>
        </Sidebar>
        <div className="employee-location-map-image-container">
          <div className="employee-location-map-container">
            <div className="map-controls-row">
              <FollowersOnlyToggle
                checked={this.props.isFollowersOnlyChecked}
                onChange={this.props.onFollowersOnlyChange}
              />
              <div className="switch-all-devices-container">
                <div>
                  <div className='switch-all-devices-container-text'>すべての</div>
                  <div className='switch-all-devices-container-text'>デバイス</div>
                </div>
                <InputSwitch
                  checked={isDisplayAllDeviceChecked}
                  onChange={e =>
                    this.updateAllDeviceChecked({
                      isCheck: e.target.value,
                    })
                  }
                />
              </div>
              <div className="zoom-controls">
                <button
                  className="zoom-button zoom-out"
                  onClick={() => this.mapZoomRef.current && this.mapZoomRef.current.zoomOut()}
                  type="button"
                >
                  <img src="/assets/img/zoom-out-icon.svg" alt="Zoom Out" />
                </button>
                <button
                  className="zoom-button zoom-fit"
                  onClick={() => this.mapZoomRef.current && this.mapZoomRef.current.resetTransform()}
                  type="button"
                >
                  <img src="/assets/img/zoom-fit-icon.svg" alt="Zoom Fit" />
                </button>
                <button
                  className="zoom-button zoom-in"
                  onClick={() => this.mapZoomRef.current && this.mapZoomRef.current.zoomIn()}
                  type="button"
                >
                  <img src="/assets/img/zoom-in-icon.svg" alt="Zoom In" />
                </button>
              </div>
            </div>
            <ReactImageMarkerNotDraggable
              triggerEmployeeDetailSidebar={triggerEmployeeDetailSidebar}
              extraClass="custom-image-marker"
              bufferLeft={0}
              bufferTop={0}
              src={floorMapUrl}
              markerComponent={EmployeeMarkerRender}
              markers={floorMapError ? [] : floorMapDataMarkers || []}
              alt=""
              ref={this.mapZoomRef}
            />
            <>
              {floorMapError && (
                <Message
                  severity="error"
                  text={COMMON_TEXT.CANNOT_LOAD_FLOORMAP}
                />
              )}
            </>
          </div>
        </div>
      </div>
    );
  }
}

EmployeeLocationMap.propTypes = {
  data: PropTypes.array,
  isLoading: PropTypes.bool,
  floorMapError: PropTypes.bool,
  floorMapUrl: PropTypes.string,

  isDisplayAllDeviceChecked: PropTypes.bool,
  updateAllDeviceChecked: PropTypes.func,

  followedEmployeeIds: PropTypes.instanceOf(Set),
  onFollowChange: PropTypes.func,

  isFollowersOnlyChecked: PropTypes.bool,
  onFollowersOnlyChange: PropTypes.func,
};

export default EmployeeLocationMap;
